import { tieneIncidencia } from '../utils/tieneIncidencia';
import { sbSignedUrl } from '../services/supabase-api';

// ── Tarjeta de registro (reutilizable) ───────────────────────────
export const TarjetaRegistro = ({ r, onValidar, onRechazar, onEliminar, onExport, esAdmin, seleccionable, seleccionado, onToggleSeleccion }) => (
  <div
    className={`bg-white rounded-xl shadow p-4 space-y-2 transition-all ${seleccionado ? "ring-2 ring-blue-500 bg-blue-50" : tieneIncidencia(r) ? "ring-2 ring-red-400" : ""}`}
    onClick={seleccionable ? () => onToggleSeleccion(r.id) : undefined}
    style={seleccionable ? { cursor: "pointer" } : {}}
  >
    <div className="flex items-center justify-between">
      {seleccionable && (
        <input
          type="checkbox"
          checked={!!seleccionado}
          onChange={() => onToggleSeleccion(r.id)}
          onClick={e => e.stopPropagation()}
          className="w-5 h-5 accent-blue-600 flex-shrink-0 mr-1"
        />
      )}
      <div className="flex-1">
        <p className="font-semibold text-gray-800 text-sm">{r.tipo}</p>
        <p className="text-xs text-gray-400">{r.fecha} · {r.hora}</p>
      </div>
      <div className="flex items-center gap-1">
        {tieneIncidencia(r) && <span className="text-xs font-bold px-2 py-1 rounded-full bg-red-100 text-red-700">⚠️</span>}
        <span className={`text-xs font-semibold px-2 py-1 rounded-full ${r.estado === "validado" ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}>
          {r.estado === "validado" ? "✅ Validado" : "⏳ Pendiente"}
        </span>
      </div>
    </div>
    {r.datos?.nombre && <p className="text-xs text-gray-600">👤 {r.datos.nombre}</p>}
    {r.datos?.matricula && <p className="text-xs text-gray-600">🚗 {r.datos.matricula}</p>}
    {r.datos?.equipo && <p className="text-xs text-gray-600">🔧 {r.datos.equipo}</p>}
    {r.datos?.dia && <p className="text-xs text-gray-600">📅 {r.datos.dia} · {r.datos.horaRecogida} — {r.datos.horaDevolucion}</p>}
    {r.datos?.contenedor && <p className="text-xs text-gray-600">📦 {r.datos.contenedor}</p>}
    {r.datos?.titulo && <p className="text-xs text-gray-600 font-semibold">📄 {r.datos.titulo}</p>}
    {r.datos?.descripcion && <p className="text-xs text-gray-500">💬 {r.datos.descripcion}</p>}
    {r.datos?.incidencia && <p className="text-xs text-gray-600">🔧 {r.datos.incidencia}</p>}
    {r.validado_por && <p className="text-xs text-green-700 font-semibold">✅ Validado por: {r.validado_por}</p>}
    {r.datos?.mes && <p className="text-xs text-gray-600">📅 {r.datos.mes} {r.datos.anio || ""}{r.datos.semana ? ` S${r.datos.semana}` : ""}</p>}
    {r.datos?.archivoUrl && (
  <div className="mt-2 space-y-2">
    {r.datos.archivoTipo?.startsWith("image/") && (
      <img src={r.datos.archivoUrl} alt="documento" className="w-full rounded-lg border border-gray-200 max-h-48 object-contain bg-gray-50"
        onError={async (e) => {
          const url = await sbSignedUrl(r.datos.archivoUrl);
          if (url) e.target.src = url;
        }}
      />
    )}
    <button
      onClick={async (e) => {
        e.stopPropagation();
        const url = await sbSignedUrl(r.datos.archivoUrl);
        if (url) window.open(url, "_blank");
      }}
      className="flex items-center gap-2 bg-blue-50 border border-blue-200 text-blue-700 text-xs font-bold px-3 py-2 rounded-lg hover:bg-blue-100 w-full"
    >
      📥 {r.datos.archivoTipo?.startsWith("image/") ? "Ver / Descargar imagen" : "📄 Ver / Descargar PDF"} — {r.datos.archivoNombre}
    </button>
  </div>
)}
    <div className="flex gap-2 pt-1" onClick={e => e.stopPropagation()}>
      {esAdmin && onValidar && (
        <button onClick={() => onValidar(r.id)} className="flex-1 bg-green-500 text-white text-xs font-bold py-2 rounded-lg hover:bg-green-600">✅ Validar</button>
      )}
      {esAdmin && onRechazar && (
        <button onClick={() => onRechazar(r.id)} className="flex-1 bg-red-500 text-white text-xs font-bold py-2 rounded-lg hover:bg-red-600">❌ Rechazar</button>
      )}
      {esAdmin && onEliminar && (
        <button onClick={() => onEliminar(r.id)} className="flex-1 bg-red-500 text-white text-xs font-bold py-2 rounded-lg hover:bg-red-600">🗑️ Eliminar</button>
      )}
      <button onClick={() => onExport(r)} className="bg-gray-100 text-gray-700 text-xs font-bold py-2 px-3 rounded-lg hover:bg-gray-200 border border-gray-200">📄</button>
    </div>
  </div>
);
